<template>
  <section class="image-float full-page-section" :class="className">
  </section>
</template>

<script>
export default {
  name: 'ImageFloat',
  data () {
    return {
      page: {}
    }
  },
  props: {
    className: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .image-float {
    background-size: auto 80%;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .tshirt {
    background-image: url('../assets/new/tshirt-min.png');
    background-size: auto 80%;
  }
  .booklet {
    background-image: url('../assets/new/report-min.png');
    background-size: auto 60%;
  }
</style>
